/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 날짜관련 유틸리티 함수 모음
 * 버전 : 1.0
 * 파일명 : DateUtils.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정 : 2026-02-04, 강동형 : parseDateToCommon 함수 추가
 *================================================================*/

// 날짜를 문자 혹은 Date값으로 넣으면 오늘 날짜와 비교해 차이값을 구함
export const getDateDifference = (dateInput: string | Date): number => {
  if (!dateInput) return -1000;

  const date =
    typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  const today = new Date();
  today.setHours(0, 0, 0, 0); // 오늘 00:00:00

  const targetDate = new Date(date);
  targetDate.setHours(0, 0, 0, 0); // 비교 대상도 00:00:00

  const diffTime = today.getTime() - targetDate.getTime();
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

// 날짜를 문자 혹은 Date값으로 넣으면 오늘 날짜와 비교해 일,주,달,년별로 지난날을 표기함
export const getDatePast = (dateInput: string | Date): string => {
  const diffDays = getDateDifference(dateInput);

  if (diffDays === 0) return '오늘';
  if (diffDays < 7) return `${diffDays}일 전`;

  const diffWeeks = Math.floor(diffDays / 7);
  if (diffDays < 30) return `${diffWeeks}주 전`;

  const diffMonths = Math.floor(diffDays / 30);
  if (diffDays < 365) return `${diffMonths}달 전`;

  const diffYears = Math.floor(diffDays / 365);
  return `${diffYears}년 전`;
};

//입력한 날짜값을 년,월,일로 표기
export const parseDateToKorean = (input: string | null): string => {
  if (!input) return ''; // 또는 '날짜 없음' 등

  const date = typeof input === 'string' ? new Date(input) : input;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}년 ${month}월 ${day}일`;
};

//입력한 날짜값을 YYYY.MM.DD로 표기
export const parseDateToCommon = (input: string | null): string => {
  if (!input) return ''; // 또는 '날짜 없음' 등

  const date = typeof input === 'string' ? new Date(input) : input;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0부터 시작하므로 +1
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}.${month}.${day}`;
};

//입력한 날짜값이 몇요일인지를 구함
export const getDayOfWeek = (dateStr: string): string => {
  if (!dateStr) return ''
  const days = ["일", "월", "화", "수", "목", "금", "토"];

  // 문자열을 Date 객체로 변환
  const date = new Date(dateStr);
  
  const dayOfWeek = days[date.getDay()];

  return dayOfWeek;
};